import classNames from 'classnames';
import React from 'react';

import { Button, ButtonSizes, ButtonVariant, Icon, useModal } from '@/shared/ui';

import { useNotifications } from '../model';

import { NotificationsModal } from './NotificationsModal';

import './NotificationsStyles.scss';

interface Props {
  className?: string;
}

export const Notifications = React.memo<Props>(({ className }) => {
  const { isOpen, toggleModal } = useModal();
  const { groupedNotifications, isLoading, loadMore, hasMore } = useNotifications();

  return (
    <>
      <NotificationsModal
        isOpen={isOpen}
        isLoading={isLoading}
        groupedNotifications={groupedNotifications}
        toggleModal={toggleModal}
        loadMore={loadMore}
        hasMore={hasMore}
      />
      <Button
        variant={ButtonVariant.ICON}
        size={ButtonSizes.SM}
        className={classNames('notifications__btn', className)}
        onClick={toggleModal}
      >
        <Icon name="notifications" width={20} height={20} />
      </Button>
    </>
  );
});
